import { httpGet, httpPost, httpPatchMerge, httpDelete } from './http'
import type { ILocationCompanyContact } from '~/types/locationCompanyContact/models'
import type { TEntityId } from '~/types/models'
import { Contact } from '~/cynqueModules/dataObjects/Contact'

const apiEntityPath = '/api/locationcompanycontacts'

export async function getLocationCompanyContacts({
  apiPath = apiEntityPath,
} = {}) {
  const callingMn = getLocationCompanyContacts.name
  return httpGet<ILocationCompanyContact[]>({ callingMn, apiPath })
}

export async function getLocationCompanyContactsPreProcessed({
  apiPath = apiEntityPath,
} = {}) {
  const callingMn = getLocationCompanyContacts.name
  const rawLocationCompanyContacts = await httpGet<ILocationCompanyContact[]>({
    callingMn,
    apiPath,
  })
  return rawLocationCompanyContacts.map((rawLocationCompanyContact) => {
    let companyContact = rawLocationCompanyContact.companyContact
    companyContact = Object.assign(companyContact, Contact(companyContact))
  })
}

export async function createLocationCompanyContact(
  entity: ILocationCompanyContact
) {
  const callingMn = createLocationCompanyContact.name
  const apiPath = apiEntityPath
  return httpPost<ILocationCompanyContact>({ callingMn, apiPath, entity })
}

export async function updateLocationCompanyContact(
  entityData: Partial<ILocationCompanyContact>,
  id: TEntityId
) {
  const callingMn = updateLocationCompanyContact.name
  const apiPath = `${apiEntityPath}/${id}`
  type TPartialILocationCompanyContact = Partial<ILocationCompanyContact>
  return httpPatchMerge<TPartialILocationCompanyContact>({
    callingMn,
    apiPath,
    entityData,
  })
}

export async function deleteLocationCompanyContact(
  entityData: ILocationCompanyContact
) {
  const callingMn = deleteLocationCompanyContact.name
  const apiPath = apiEntityPath
  return httpDelete<ILocationCompanyContact>({
    callingMn,
    apiPath,
    entityData,
  })
}
